import { render, staticRenderFns } from "./tempIntroDetail.vue?vue&type=template&id=d542a64e&scoped=true&"
import script from "./tempIntroDetail.vue?vue&type=script&lang=js&"
export * from "./tempIntroDetail.vue?vue&type=script&lang=js&"
import style0 from "./tempIntroDetail.vue?vue&type=style&index=0&id=d542a64e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d542a64e",
  null
  
)

export default component.exports